import { useSelector } from 'react-redux';

import usePhotoSession from 'data/react-query/queries/usePhotoSession';
import { selectPhotoSessionDetail } from 'containers/PhotoSessionDetail/selectors';

// Uses the detail in the store when present; otherwise fetches it (agenda card, refresh, deep link).
const useRescheduleSessionDetail = (photoSessionId) => {
  const storeDetail = useSelector(selectPhotoSessionDetail);
  const hasStoreDetail = !!storeDetail && storeDetail.id === Number(photoSessionId);

  const query = usePhotoSession(photoSessionId, {
    enabled: !hasStoreDetail && !!photoSessionId,
  });

  return {
    photoSessionDetail: hasStoreDetail ? storeDetail : query.data,
    isLoading: !hasStoreDetail && query.isLoading,
    isError: !hasStoreDetail && query.isError && !query.data,
    refetch: query.refetch,
  };
};

export default useRescheduleSessionDetail;
